// extracted by mini-css-extract-plugin
export default {"geomapHeader":"geoMap_geomapHeader__6qjKq","geomapBody":"geoMap_geomapBody__mO1d3","geomapFooter":"geoMap_geomapFooter__GG1QK"};